import styled from 'styled-components';

const NonAdminUser = styled.h5`
  font-size: 1.4rem;
  font-weight: 600;
  height: 38px;
  margin-bottom: -0.95rem;
  padding-left: 4px;
`;

export {
  NonAdminUser
};
